<div
  id="vst-label-{{ key }}"
  class="visual-sales-tool__label visual-sales-tool__label--{{ key }}"
  (click)="updateState()"
  [ngClass]="{ 'visual-sales-tool__label--disabled': !displayState }"
>
  <div class="visual-sales-tool__label-name">{{ label }}</div>
  <div class="visual-sales-tool__label-value">{{ value }}</div>
</div>
